import React, { useEffect, useState } from 'react'

export default function GlobalPaging({ OnPageChange, pagingData, text = "Entries", children, loading = false }) {
    return (
        <div>
            {children}
            {pagingData && <div className='mt-4 h-12 w-full'>
                <div class="p-2 flex items-center justify-between">
                    <span class="text-sm text-gray-400">
                        {pagingData &&
                            <>Showing <span class="font-semibold">{pagingData.firstItemOnPage}</span>-<span class="font-semibold ">{pagingData.lastItemOnPage}</span> of <span class="font-semibold ">{pagingData.totalItemCount}</span></>
                        }
                    </span>
                    <div class="inline-flex xs:mt-0">
                        <button value={parseInt(pagingData.pageNumber) - 1} onClick={OnPageChange} disabled={loading || pagingData.isFirstPage} class={pagingData.isFirstPage ? "cursor-not-allowed flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-brand-300 rounded-s" : "flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-brand-400 rounded-s hover:bg-brand-500"}>
                            <svg class="w-3.5 h-3.5 me-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
                            </svg>
                            
                        </button>
                        <button value={parseInt(pagingData.pageNumber) + 1} onClick={OnPageChange} disabled={loading || pagingData.isLastPage} class={pagingData.isLastPage ? "cursor-not-allowed flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-brand-300 border-0 border-s border-brand-700 rounded-e" : "flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-brand-400 border-0 border-s border-brand-700 rounded-e hover:bg-brand-500"}>
                            
                            <svg class="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}
